//import { elementScrollIntoView  } from "seamless-scroll-polyfill";

import smoothscroll from 'smoothscroll-polyfill';
import React, { useState , useEffect } from 'react'
import {config} from '../config'

//import SelectSearch, { fuzzySearch } from 'react-select-search';

import Select from 'react-select';



const txdomain = config()['tourneyx-url']

const SearchUserRanking  = ({ registeredAnglers , tournamentInfo  }) => {

    const [selected, setSelected] = useState("");
    const [value, setValue] = useState();

    const [width, setWidth] = useState(window.innerWidth);

    // kick off the polyfill!
    smoothscroll.polyfill();

    var anglers_list = [];

    var user_record_to_be_searched = '';

    anglers_list =  registeredAnglers.map(({ user_id,angler_name }) => (  { value: user_id, name: angler_name } ));

    //let options = [];

   // options = registeredAnglers.map( x => x );

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }


    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isMobile =  Boolean( width <= 768);

    function onUserSelect( e ) {

        user_record_to_be_searched = e;

        console.log('Angler name selected for search record  :::', user_record_to_be_searched,isMobile);

        if( isMobile === false) {
            const search_items = Array.from(document.querySelectorAll(".standing-user-list"));
            const last = search_items.filter(item => item?.id === user_record_to_be_searched);
    
            console.log('last OUTPUT :::', last,isMobile);
    
            const temp_last = last[0];
            
            //elementScrollIntoView(temp_last, { behavior: "smooth", block: "center", inline: "center" });

            //elementScrollIntoView(temp_last, { behavior: "smooth"});

            temp_last.scrollIntoView({ block: "center", inline: "center" });


        }else if( isMobile === true ){

            const search_items = Array.from(document.querySelectorAll(".standing-mobile-view-user-list"));
            const last = search_items.filter(item => item?.id === user_record_to_be_searched);
    
            console.log('last OUTPUT in mobile view :::', last,isMobile);
    
            const temp_last = last[0];
            
            //elementScrollIntoView(temp_last, { behavior: "smooth", block: "center", inline: "center" });

            //elementScrollIntoView(temp_last, { behavior: "smooth"});

            temp_last.scrollIntoView({ block: "center", inline: "center" });
            
        }


    }

    function supportsSmoothScrolling() {
        const body = document.body;
        const scrollSave = body.style.scrollBehavior;
        body.style.scrollBehavior = 'smooth';
        const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
        body.style.scrollBehavior = scrollSave;
        return hasSmooth;
      };

    function SmoothVerticalScrolling(e, time, where) {
        var eTop = e.getBoundingClientRect().top;
        var eAmt = eTop / 100;
        var curTime = 0;
        while (curTime <= time) {
            window.setTimeout(SVS_B, curTime, eAmt, where);
            curTime += time / 100;
        }
    }
    
    function SVS_B(eAmt, where) {
        if(where == "center" || where == "")
            window.scrollBy(0, eAmt / 2);
        if (where == "top")
            window.scrollBy(0, eAmt);
    }

    function onUserSearchSelect( e ) {


        user_record_to_be_searched = e.value;
        setValue(e.value);
        
        console.log('Value set after selection :::', value);

        console.log('Angler id selected for search record  :::', user_record_to_be_searched,isMobile);

        if( isMobile === false) {
            const search_items = Array.from(document.querySelectorAll(".standing-user-list"));
            const last = search_items.filter(item => item?.id === user_record_to_be_searched);
    
            console.log('last OUTPUT :::', last,isMobile);
    
            const temp_last = last[0];
            
            //elementScrollIntoView(temp_last, { behavior: "smooth", block: "center", inline: "center" });

            //SmoothVerticalScrolling(temp_last, 300, "center");

            temp_last.scrollIntoView({ block: "center", inline: "center" });

        }else if( isMobile === true ){

            const search_items = Array.from(document.querySelectorAll(".standing-mobile-view-user-list"));
            const last = search_items.filter(item => item?.id === user_record_to_be_searched);
    
            console.log('last OUTPUT in mobile view :::', last,isMobile);
    
            const temp_last = last[0];
            
            //elementScrollIntoView(temp_last, { behavior: "smooth", block: "center", inline: "center" });


            temp_last.scrollIntoView({ block: "center", inline: "center" });
            
            //SmoothVerticalScrolling(temp_last, 300, "center");
            
        }


    }

    function MakeOption(x) {
        return { value: x.user_id, label: x.angler_name };
    }

    const options = registeredAnglers && registeredAnglers.map(user =>{
        return {value: user.user_id, label: user.angler_name}
    })

    return (
        <>
                

                <Select
                    options={options}
                    value = {options.label}
                    onChange={onUserSearchSelect}
                    search
                    className = 'react-select-container'
                    classNamePrefix="react-select"
                    placeholder="--Search Angler--"
                    
                />

        </>
    )
}

export default SearchUserRanking